import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncHelpCenterSettingsSidebar from '@atlassian/jira-navigation-apps-sidebar-help-center-settings/src/async.tsx';

export const navigation = {
	sidebarId: SIDEBAR_ID.HELP_CENTER_SETTINGS,
	menuId: MENU_ID.HELP_CENTER_SETTINGS,
	sidebar: AsyncHelpCenterSettingsSidebar,
};

export const agentStudioNavigation = {
	sidebarId: SIDEBAR_ID.HELP_CENTER_SETTINGS,
	menuId: MENU_ID.HELP_CENTER_SETTINGS,
	sidebar: AsyncHelpCenterSettingsSidebar,
};
